import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProductSubtypeEnum } from '@app/models/enums/product-subtype.enum';
import { GEProductInterface } from '@app/products/ge/assays/models/interfaces/ge-product.interface';
import { StoreService } from '@app/services/store.service';
import { Direction } from '@app/modules/tf-sort-by';
import { AnalyticsService } from '@app/services/analytics.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'tf-search-results-header',
    templateUrl: './search-results-header.component.html',
    styleUrls: ['./search-results-header.component.scss']
})
export class TfSearchResultsHeaderComponent implements OnInit, OnDestroy {

    currentSortBy: string | null = null;
    currentSortDirection: Direction | null = null;

    checked: boolean = false;
    isPartial: boolean = false;

    private subscriptions: Subscription = new Subscription();

    getProducts(): GEProductInterface[] {
        return this.storeService.searchResults$.getValue()?.products[ProductSubtypeEnum.ge] || [];
    }

    constructor(
        private analyticsService: AnalyticsService,
        public storeService: StoreService
    ) {
    }

    ngOnInit(): void {

        const resultsSubscription = this.storeService.selectedResults$.subscribe((results) => {

            if (results === null) {
                return;
            }

            const selectedProducts = results.products || [];

            this.checked = selectedProducts.length > 0;
            this.isPartial = selectedProducts.length < this.getProducts().length;

        });

        this.subscriptions.add(resultsSubscription);

        const searchParamsSubscription = this.storeService.searchParams$.subscribe((searchParams) => {

            this.currentSortBy = searchParams.sortBy;

            if (searchParams.sortOrder === 'ascending') {
                this.currentSortDirection = Direction.ascending;
            }

            if (searchParams.sortOrder === 'descending') {
                this.currentSortDirection = Direction.descending;
            }

        });

        this.subscriptions.add(searchParamsSubscription);

    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    onSort(data: any): void {

        this.currentSortBy = data.sortBy;
        this.currentSortDirection = data.direction;

        if (this.currentSortDirection != null) {

            this.storeService.changeSearchParams({
                sortBy: data.sortBy,
                sortOrder: data.direction,
                limit: '' + this.storeService.getLoadedProductsCount(),
                offset: '0'
            });

            this.storeService.doSearch();

        }

    }

    handleCheckChange(event: Event | any): void {

        if (event.checked) {
            this.storeService.selectAllProducts();
            this.analyticsService.selectAllClicked();
        } else {
            this.storeService.unselectAllProducts();
        }

    }

}
